import { app } from '../../../../../app';

app.config(config);

/** @ngInject */
function config($stateProvider) {
    $stateProvider.state('company.saaspass-connect.manage.access-control-policy', {
        url: '/access-control-policy',
        component: 'companyManageSaaspassConnectAccessControlPolicy',
        resolve: {authenticationAccessPolicyList},
    });
}

/** @ngInject */
function authenticationAccessPolicyList(AuthenticationAccessPolicyResource, companyId) {
    const type='basic';
    return AuthenticationAccessPolicyResource.getAuthenticationAccessPolicyList(companyId,type);
}


// WEBPACK FOOTER //
// ./src/portal/states/company/saaspass-connect/manage/access-control-policy/oidc-access-control-policy.state.js